// Mock content for the PL16 — Lotus 16th Anniversary Tote landing page (light theme).
// All data is front-end only (no backend yet).

export const brand = {
  name: 'PL16',
  full: 'Lotus 16th Anniversary',
  dealsUrl: 'https://plpcsanjose.com/deals',
  city: 'Bay Area, CA',
  store: {
    name: 'Purple Lotus',
    address: '752 Commercial Street, San Jose, CA',
    mapsUrl: 'https://www.google.com/maps/dir/?api=1&destination=752+Commercial+Street+San+Jose+CA',
  },
  marks: {
    // dark (ink) variants for the light theme
    lotus: '/branding/lotus-mark-dark.png',
    fl: '/branding/fl-lockup-dark.png',
    pl16: '/branding/pl16-badge-dark.png',
    anniversary: '/branding/anniversary-16-dark.png',
    // original white variants for the dark footer
    lotusLight: '/branding/lotus-mark-t.png',
  },
};

export const nav = [
  { label: 'The Tote', href: '#top' },
  { label: 'Colors', href: '#colours' },
  { label: 'The Story', href: '#story' },
  { label: 'Details', href: '#details' },
];

// Hero scroll-synced text states (progress 0 -> 1) — clean + restrained
export const heroStates = [
  { at: 0.0, kicker: '16th Anniversary Edition', line: ['Sixteen years.', 'One tote.'] },
  { at: 0.4, kicker: 'Organic cotton canvas', line: ['Made to', 'be carried.'] },
  { at: 0.74, kicker: '20 in each color', line: ['Yours, while', 'they last.'] },
];

export const product = {
  name: 'The Lotus Tote',
  edition: '16th Anniversary Edition',
  price: '£68',
  blurb:
    'A heavyweight carry-everything tote, made to mark sixteen years. Structured organic canvas, the Purple Lotus emblem, and a finish built to soften with every journey.',
  image: '/product-tote.jpg',
  bullets: [
    '510gsm organic cotton canvas',
    'Purple Lotus emblem, screen-printed',
    'Reinforced 70cm webbed handles',
    'Interior pocket, riveted base',
  ],
};

export const launch = {
  status: 'coming-soon',
  // Halloween drop — phase 1 (delivery only): October 26, 08:00 local time
  month: 9, // October (0-indexed)
  day: 26,
  hour: 8,
  minute: 0,
  dateLabel: 'October 26',
  phase1: 'Delivery only · Oct 26',
  phase2: 'In-store + delivery · Oct 30',
  bundleLine: 'Spend $200, get a free tote',
  offer: 'Spend $200 on delivery or in store, get a free limited-edition tote ($25 value)',
  bundleNote: 'Spend $200 on delivery or in store this Halloween and the limited-edition Lotus Tote is yours free — a $25 value, while stock lasts.',
};

export const bundle = {
  title: 'The Lotus Bundle',
  intro:
    'The 16th Anniversary drop lands September 4, Labor Day weekend. Order a delivery for $200 and the limited-edition Lotus Tote is yours free — a $25 value.',
  items: [
    { qty: '3.5g', name: 'Blue Chip' },
    { qty: '7g', name: 'Chill Guy' },
    { qty: 'Free', name: 'Lotus Tote' },
  ],
};

export const lookbook = {
  singles: [
    { src: '/products/black.png', name: 'Black', dot: '#f59e0b' },
    { src: '/products/nightshade.png', name: 'Nightshade', dot: '#7c4dff' },
    { src: '/products/toxic.png', name: 'Toxic', dot: '#9ccc1f' },
    { src: '/products/violet.png', name: 'Violet', dot: '#8b5cf6' },
  ],
  groupBanner: '/products/hw-group-banner.png',
};

export const colourways = [
  { name: 'Black', color: '#1a1a1a', src: '/products/black.png' },
  { name: 'Nightshade', color: '#7c4dff', src: '/products/nightshade.png' },
  { name: 'Toxic', color: '#9ccc1f', src: '/products/toxic.png' },
  { name: 'Violet', color: '#8b5cf6', src: '/products/violet.png' },
];

export const stats = [
  { value: '16', suffix: 'yrs', label: 'In the making' },
  { value: '20', suffix: 'pcs', label: 'Per color' },
  { value: '100', suffix: '%', label: 'Organic canvas' },
  { value: '01', suffix: '', label: 'Signature lotus' },
];

export const features = [
  { no: '01', title: 'Built to be lived in', text: 'Heavyweight 510gsm canvas holds its shape, then softens beautifully across the years it’s carried.' },
  { no: '02', title: 'The Purple Lotus mark', text: 'Our emblem, embroidered to perfection — the same lotus that’s carried the brand for sixteen years.' },
  { no: '03', title: 'Numbered and final', text: 'Just 20 totes in each color. Every piece is logged and never remade once the drop closes.' },
  { no: '04', title: 'Made with organic inputs', text: 'Built to last and sourced from quality suppliers.' },
];

export const gallery = [
  { src: '/gallery-tote.jpg', tall: true, brand: true },
  { src: 'https://images.unsplash.com/photo-1572196223922-d8b7e0ab0b4d', tall: false },
  { src: 'https://images.pexels.com/photos/14967410/pexels-photo-14967410.jpeg', tall: false },
  { src: 'https://images.pexels.com/photos/7129196/pexels-photo-7129196.jpeg', tall: true },
];

export const quote = {
  text:
    'Sixteen years in, and this is the piece we’re proudest to put our name on. The whole story, in something you’ll actually use.',
  author: 'The PL16 Studio',
  role: 'On the Anniversary Edition',
};
